/**
 * Created by imranexpt on 08/04/2016.
 */
(function() {
    /** @ngInject */
    function invitationCtrl($scope, $timeout){
        $scope.errors = [];
        $scope.invite = {emails : '', message : ''};
        $scope.saveInvite = function(){
            var emails = $scope.invite.emails;
            if(_.size(emails) <= 0){
                setError('Please enter email addresses');
                return false;
            }
            $scope.booking.sendInvitation(emails, $scope.invite.message).success(function(response){
                if(response.success == false) {
                    setError(response.errors);
                    return false;
                }
                $scope.booking.invitations = true;
                $scope.cancelInvite();
            });
        };
        $scope.cancelInvite = function(){
            $scope.invite = {emails : '', message : ''};
            $scope.setTemplate('');
        };
        function setError(error){
            $scope.errors.push(error);
            $timeout(function(){
                $scope.errors = [];
            }, 5000);
        }
        window.setTimeout(sendHeightEvent, 800);
    }
    angular.module("Waiteraid").controller("bookingInvitationCtrl", invitationCtrl);
})();
